export default {
      id: "icon-marker-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "icons.svg#icon-marker",
      toString: function () {
        return this.url;
      }
    }